export default __webpack_public_path__ + "static/media/dark_upload.1488b76d.svg";